import ManageVideo from 'assets/videos/unique_version_management_video3.mp4';
import TweakVideo from 'assets/videos/unique_version_tweak_video2.mp4';
import UniqueVersions from 'assets/videos/unique_version_video1.mp4';
import ComparisionVersions from 'assets/videos/unique_versions_comparison_video4.mp4';

export const getVideo = (value: string) => {
    switch (value) {
        case 'comparision_multiple_versions':
            return ComparisionVersions;
        case 'manage_multiple_versions':
            return ManageVideo;
        case 'refine_generated_job_posts':
            return TweakVideo;
        case 'generate_multiple_unique_versions':
            return UniqueVersions;
        default:
            return null;
    }
};
